export default __webpack_public_path__ + "static/media/safe7-intro-fa.9dbd5d56.png";